import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=c72aa0d8"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72aa0d8')) {
      api.createRecord('c72aa0d8', component.options)
    } else {
      api.reload('c72aa0d8', component.options)
    }
    module.hot.accept("./Catalogs.vue?vue&type=template&id=c72aa0d8", function () {
      api.rerender('c72aa0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/Catalogs.vue"
export default component.exports